import * as Common_en from './Common.en.js';
import * as Common_es from './Common.es.js';

const CommonTuple = [
  { type: 'Common', language: 'en', object: Common_en.default },
  { type: 'Common', language: 'es', object: Common_es.default },
];

export default CommonTuple;
